<template>
    <div v-if="profile" class="user-menu-header">
        <div v-if="!profile.avatar" class="avatar green" @click.prevent>
            <div class="shortname">{{ shortName }}</div>
        </div>
        <div v-else class="avatar" @click.prevent>
            <div class="img" :style="{ backgroundImage: `url(${profile.avatar})` }"></div>
        </div>
        <div class="name green" @click.prevent>{{ fullName }}</div>
    </div>
</template>

<script setup lang="ts">
    import type { IProfile } from "@/data/model/Profile";
    import { OperatorClient } from "@/operator/OperatorClient";
    import { onMounted, ref } from "vue";

    const profile = ref<IProfile>();
    const shortName = ref<string>();
    const fullName = ref<string>();

    function shortNameFromProfile(profile: IProfile): string {
        let sn = "";

        if (profile.firstName !== undefined && profile.firstName.length > 0) {
            sn += profile.firstName.substr(0, 1);
        }

        if (profile.lastName !== undefined && profile.lastName.length > 0) {
            sn += profile.lastName.substr(0, 1);
        }

        return sn;
    }

    onMounted(() => {
        profile.value = OperatorClient.context.profile!;
        shortName.value = shortNameFromProfile(profile.value);
        fullName.value = `${profile.value.firstName} ${profile.value.lastName}`;
    });
</script>

<style lang="scss">
    @use "./../../../../assets/styles/scss/shared/_colors.scss";

    .user-menu-header {
        height: 117px;
        background-color: #fafafa;
        border-bottom: 1px solid #ededed;
        width: 100%;
        text-align: center;
        box-sizing: border-box;
        padding: 14px 50px 0 0;

        > .avatar {
            height: 64px;
            width: 64px;
            overflow: hidden;
            border-radius: 33px;
            border: 1px solid #ededed;
            display: inline-block;
            vertical-align: top;

            &.green {
                border-color: colors.$green;
            }

            > .img {
                width: 100%;
                height: 100%;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
            }

            > .shortname {
                text-align: center;
                font-size: 26px;
                color: colors.$green;
                line-height: 66px;
            }
        }

        > .avataricon {
            font-size: 66px;
            height: 66px;
            width: 66px;
            display: inline-block;
            vertical-align: top;
            text-align: center;

            > .fas {
                display: block;
                color: #afafaf;
                line-height: 64px;
            }
        }

        > .name {
            font-size: 14px;
            padding: 5px 0 0 0;

            &.green {
                color: colors.$green;
                text-align: center;
            }
        }
    }
</style>
